module.exports = __webpack_public_path__ + "img/map_baseline-pavilion.34f34e7d.jpg";